module.exports = __webpack_public_path__ + "static/img/bg_cw.faddf157.png";